module.exports = __webpack_public_path__ + "img/gd.11a3bd95.svg";